module.exports = __webpack_public_path__ + "static/media/menuStopwatch.1241fbb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuStopwatch.svg
// module id = 485
// module chunks = 0